/**
 * FEMETRY — PDP behaviors: gallery thumb switching, supplement-facts dialog,
 * and the one-time / subscribe toggle. Subscribe selection writes the selling
 * plan id (when Skio plans exist, P4) into the form's selling_plan input;
 * one-time clears it. Plain custom element, no build step.
 */
class FemetryPdp extends HTMLElement {
  connectedCallback() {
    // gallery
    this.main = this.querySelector('[ref="mainMedia"] img');
    this.querySelectorAll('.femetry-pdp__thumb').forEach((thumb) =>
      thumb.addEventListener('click', () => {
        this.querySelectorAll('.femetry-pdp__thumb').forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        if (this.main) {
          this.main.src = thumb.dataset.full;
          this.main.removeAttribute('srcset');
        }
      })
    );

    // supplement facts dialog
    const dialog = this.querySelector('[ref="factsDialog"]');
    this.querySelector('[ref="factsOpen"]')?.addEventListener('click', () => dialog?.showModal());
    this.querySelector('[ref="factsClose"]')?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', (e) => {
      if (e.target === dialog) dialog.close();
    });

    // purchase toggle → selling_plan input
    const planInput = this.querySelector('[ref="sellingPlanInput"]');
    this.querySelectorAll('input[name="femetry-purchase-type"]').forEach((radio) =>
      radio.addEventListener('change', () => {
        if (!planInput) return;
        planInput.value = radio.value === 'subscribe' ? planInput.dataset.planId || '' : '';
      })
    );
  }
}

if (!customElements.get('femetry-pdp')) {
  customElements.define('femetry-pdp', FemetryPdp);
}
